import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './GameIdeaDetail.css';

export default function GameIdeaDetail() {
  const navigate = useNavigate();
  const cursorRef = useRef(null);
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const onMove = (e) => {
      const el = cursorRef.current;
      if (!el) return;
      el.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
    };
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, []);

  return (
    <div className="gid-page">
      <div className="gid-cursor" ref={cursorRef} aria-hidden="true" />

      <div className="gid-bg">
        <div className="gid-orb gid-orb-a" />
        <div className="gid-orb gid-orb-b" />
        <div className="gid-orb gid-orb-c" />
        <div className="gid-grid" />
        <div className="gid-noise" />
      </div>

      <button className="gid-back" onClick={() => navigate('/my-work')}>
        ← My Work
      </button>

      <main className="gid-main">
        <span className="gid-status">
          <span className="gid-status-dot" />
          STATUS · WORK IN PROGRESS
        </span>

        <h1 className="gid-title">
          <span className="gid-title-line">Still figuring out</span>
          <span className="gid-title-line gid-title-glow">
            what makes it&nbsp;
            <em>fun</em>.
          </span>
        </h1>

        <p className="gid-desc">這是一個還在構想中的策略遊戲。</p>

        <div className="gid-tags">
          {['Strategy', 'Turn-Based', 'Cards', 'React', 'Prototype'].map(
            (t) => (
              <span key={t}>{t}</span>
            )
          )}
        </div>

        <div className="gid-peek">
          <button
            className={`gid-peek-toggle ${showImage ? 'active' : ''}`}
            onClick={() => setShowImage((v) => !v)}
          >
            {showImage
              ? 'Hide current prototype'
              : 'Take a peek at the prototype'}
          </button>

          <div className={`gid-peek-frame ${showImage ? 'open' : ''}`}>
            <div className="gid-peek-shine" />
            <img
              src="/images/working on idea.webp"
              alt="Game prototype work in progress"
            />
            <span className="gid-peek-tag">PROTOTYPE · v0.1 · 仍在迭代</span>
          </div>
        </div>

        <div className="gid-loader">
          <div className="gid-loader-track">
            <div className="gid-loader-bar" />
          </div>
          <span className="gid-loader-label">Brewing ideas…</span>
        </div>
      </main>
    </div>
  );
}
